import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "登录",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Login",
    name: "登录",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Home",
    name: "Bit Hero",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/agreement",
    name: "用户协议",
    component: () => import("../views/agreement.vue"),
  },
  {
    path: "/about",
    name: "了解BitHero",
    component: () => import("../views/about.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
